import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';
// import {Form, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';

import SwaggerUI from 'swagger-ui';

import {ApisService} from '../apis.service';
import {ApiDetail} from '../api-detail';
import {ApplicationDetail} from '../application-detail';
import {KeyItem} from '../key-item';
import {Subscriptions} from '../subscriptions';
import {SubscriptionItem} from '../subscription-item';
import {SubscriptionManageEventType} from '../subscription-manage/subscription-manage-event-type';
import {User} from '../../core/user/user';
import {UserService} from '../../core/user/user.service';
import {HttpErrorResponse} from '@angular/common/http';

const KEY_TYPE_PRODUCTION = 'PRODUCTION';

@Component({
  selector: 'aqx-api-detail',
  templateUrl: './api-detail.component.html',
  styleUrls: ['./api-detail.component.scss']
})
export class ApiDetailComponent implements AfterViewInit, OnInit {
  isUserEntitledApiStore = false;
  apiDetail: ApiDetail;
  apiDefinitionObject: object;
  exampleResource: string;
  invocationUri: string;
  productionKey: KeyItem;
  swaggerUi: any;

  subscriptions: Subscriptions;
  subscriptionItemSelected: SubscriptionItem;
  isSubscriptionsComplete: boolean;
  isSubscribing: boolean;
  isUnsubscribing: boolean;

  applicationDetail: ApplicationDetail;
  isApplicationDetailDone: boolean;

  constructor(private el: ElementRef, private route: ActivatedRoute, private apisService: ApisService, private userService: UserService) {
  }

  ngOnInit() {
    this.isUserEntitledApiStore = this.userService.isUserEntitledApiStore();
  }

  async ngAfterViewInit() {
    this.getApi();
  }

  receiveMessageFromSubscriptionCreate($event: any) {
    switch ($event.eventType) {
      case SubscriptionManageEventType.subscribed:
      case SubscriptionManageEventType.unsubscribed:
        this.getSubscriptions();
        break;
      case SubscriptionManageEventType.cancelled:
        break;
    }
    this.isSubscribing = false;
    this.isUnsubscribing = false;
  }

  getApi(): void {
    this.apisService.getApi(this.route.snapshot.paramMap.get('apiId'))
      .subscribe(apiDetail => {
        this.apisService.enrichApi(apiDetail);
        this.invocationUri = this.apisService.getGatewayBaseUri() + apiDetail.context + '/' + apiDetail.version;
        this.apiDetail = apiDetail;
        try {
          this.apiDefinitionObject = JSON.parse(this.apiDetail.apiDefinition);
          this.exampleResource = this.suggestSampleResource();
          this.showSwagger();

        } catch (e) {
          console.log(e);
        }
        if (this.isUserEntitledApiStore) {
          this.getSubscriptions();
        }
      });
  }

  private suggestSampleResource() {
    let suggestedResource;
    const swagger =  this.apiDefinitionObject as any;
    const paths = swagger.paths;
    for (const pathName in paths) {
      if (paths.hasOwnProperty(pathName)) {
        const path = paths[pathName];
        if (path.get) {
          suggestedResource = pathName;
          break;
        }
      }
    }
    if (!suggestedResource) {
      suggestedResource = '$RESOURCE';
    }
    return(suggestedResource);
  }

  getThumbnailUri(apiDetail) {
    return (this.apisService.getThumbnailUri(apiDetail));
  }

  showSwagger(): void {
    this.swaggerUi = SwaggerUI({
      // url: 'http://petstore.swagger.io/v2/swagger.json',
      spec: this.apiDefinitionObject,
      domNode: this.el.nativeElement.querySelector('#swagger-ui'),
      presets: [
        SwaggerUI.presets.apis
      ],
    });
  }

  getSubscriptions() {
    this.isSubscriptionsComplete = false;
    this.subscriptions = undefined;
    this.subscriptionItemSelected = undefined;
    this.apisService.getSubscriptionsForApi(this.apiDetail.id)
      .subscribe(
        subscriptions => {
          this.subscriptions = subscriptions;
          if (subscriptions.list.length > 0) {
            this.subscriptionItemSelected = subscriptions.list[0];
            // this.form = new FormGroup({
            //   state: new FormControl(this.subscriptionItemSelected),
            // });
            this.getApplicationDetail();
          }
        },
        error => {
          console.log(error);
          this.isSubscriptionsComplete = true;
        },
        () => {
          // No errors
          this.isSubscriptionsComplete = true;
        });
  }

  // TOOD: this should be moved into application-keys.component, passing through the applicationId

  getApplicationDetail() {
    this.isApplicationDetailDone = false;
    this.apisService.getApplicationDetail(this.subscriptionItemSelected.applicationId)
      .subscribe(
        applicationDetail => {
          this.applicationDetail = applicationDetail;
          this.setProductionKey();
        },
        error => {
          console.log(error);
          this.isApplicationDetailDone = true;
        },
        () => {
          // No errors
          this.isApplicationDetailDone = true;
        });
  }
  setProductionKey() {
    const keys = this.applicationDetail.keys;
    this.productionKey = keys.find( (key) => {
      return (key.keyType === KEY_TYPE_PRODUCTION);
    });

    if (this.productionKey) {
      this.swaggerUi.initOAuth({
        clientId: this.productionKey.consumerKey,
        clientSecret: this.productionKey.consumerSecret
      });
    }
  }
}
